export default __webpack_public_path__ + "static/media/girl-carrying-box.5a170596.svg";